/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Ph_Nguoi_Giao_DescInputs */

const vi_station_voice_ph_nguoi_giao_desc = /** @type {(inputs: Station_Voice_Ph_Nguoi_Giao_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài xế được gắn giao đơn (đọc nguyên văn)`)
};

/**

* @param {Station_Voice_Ph_Nguoi_Giao_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_ph_nguoi_giao_desc = /** @type {((inputs?: Station_Voice_Ph_Nguoi_Giao_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Ph_Nguoi_Giao_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_ph_nguoi_giao_desc(inputs)
});